import React, { ComponentPropsWithRef, FC } from 'react'

type SvgProps = ComponentPropsWithRef<'svg'>
type Props = SvgProps

/** └ をアイコン化したもの */
export const CornerBottomLeftIcon: FC<Props> = ({ ...props }) => {
  return (
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 0V11H12" stroke="#5E6B7B" strokeDasharray="2 2" />
    </svg>
  )
}
